import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import KanbanArchive from '../components/KanbanArchive';

export default function KanbanArchivePage() {
  const [isEditable, setIsEditable] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('adminToken');
      const expiresAt = localStorage.getItem('adminExpiresAt');

      if (!token || !expiresAt) {
        setIsEditable(false);
        setCheckingAuth(false);
        return;
      }

      if (Date.now() > parseInt(expiresAt)) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminExpiresAt');
        setIsEditable(false);
        setCheckingAuth(false);
        return;
      }

      setIsEditable(true);
      setCheckingAuth(false);
    };

    checkAuth();
  }, []);

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-retro-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-neutral-700 border-t-neutral-200" />
      </div>
    );
  }

  return (
    <div className="h-[100dvh] bg-retro-bg text-neutral-200 flex flex-col overflow-hidden">
      <header className="shrink-0 flex items-center justify-between gap-2 px-3 sm:px-6 py-3 sm:py-4">
        <div className="flex items-baseline gap-2.5 min-w-0">
          <h1 className="text-base sm:text-lg font-semibold text-neutral-100 leading-none truncate">
            Typing Stars
          </h1>
          <span className="text-xs text-neutral-500 shrink-0">archive</span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          {isEditable ? (
            <span className="px-2 py-0.5 rounded-full bg-teal-500/15 text-teal-300 text-xs">
              Editing
            </span>
          ) : (
            <span className="px-2 py-0.5 rounded-full bg-neutral-800 text-neutral-400 text-xs">
              Read-only
            </span>
          )}
          <Link
            to="/kanban"
            className="text-xs text-neutral-500 hover:text-neutral-300 transition-colors touch-manipulation"
          >
            Board
          </Link>
          {isEditable && (
            <Link
              to="/admin"
              className="text-xs text-neutral-500 hover:text-neutral-300 transition-colors touch-manipulation"
            >
              Admin
            </Link>
          )}
        </div>
      </header>

      <main className="flex-1 min-h-0 flex flex-col px-3 sm:px-6">
        <KanbanArchive isEditable={isEditable} />
      </main>
    </div>
  );
}
